import React, {useState} from 'react';
import {View, Text, StyleSheet} from 'react-native';
import TitleBlock from '../../components/TitleBlock';
import Themes from '../../themes';
import FormIF from '../../form/FormIF';

const SimuIF = ({navigation}) => {
  const [assiete, setAssiete] = useState(0);
  const [mif, setMif] = useState(0);
  const [cac, setCac] = useState(0);
  const [total, setTotal] = useState(0);

  const form = (
    <View style={[styles.scene]}>
      <FormIF
        setAssiete={setAssiete}
        setMif={setMif}
        setCac={setCac}
        setTotal={setTotal}
      />
    </View>
  );

  const results = (
    <View style={[styles.scene]}>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>ASSIETE DE L'IMPOT</Text>
        <Text style={[styles.result]}>{assiete}</Text>
      </View>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>MONTANT DE L'IMPÔT FONCIER</Text>
        <Text style={[styles.result]}>{mif}</Text>
      </View>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>
          MONTANT DES CENTIMES ADDITIONNELS (CAC)
        </Text>
        <Text style={[styles.result]}>{cac}</Text>
      </View>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>MONTANT TOTAL IMPÔT FONCIER</Text>
        <Text style={[styles.result]}>{total}</Text>
      </View>
    </View>
  );

  return (
    <>
      <TitleBlock
        bgColor={Themes.colors.lightPurple}
        textColor="white"
        image={require('../../assets/home-icon-home.png')}>
        Calcul de l'impôt foncier sur les propriétés bâties
      </TitleBlock>
      {form}
      {results}
    </>
  );
};

const styles = StyleSheet.create({
  scene: {
    flex: 1,
    padding: 20,
  },
  resultItem: {
    flexDirection: 'row',
    borderBottomWidth: 3,
    paddingVertical: 3,
    borderBottomColor: Themes.colors.lightBlue,
    borderStyle: 'dashed',
    justifyContent: 'center',
    alignItems: 'center',
  },
  label: {
    flex: 1,
    flexGrow: 2,
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
    color: Themes.colors.lightBlue,
  },
  result: {
    flex: 1,
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
    color: Themes.colors.lightBlue,
    textAlign: 'right',
  },
});

export default SimuIF;
